import { useEffect, useRef } from 'react';
/**
 * Listens globally (window) for a specific key and tracks a timed streak of presses.
 * Calls your handler on each qualifying press with (currentStreak, reset).
 */
export function useKeyStreak(key, onStreak, { ttl = 1000 } = {}) {
    const streakRef = useRef(0);
    const timeoutRef = useRef(null);
    const handlerRef = useRef(onStreak);
    useEffect(() => {
        handlerRef.current = onStreak;
    }, [onStreak]);
    useEffect(() => {
        const targetKey = key.toLowerCase();
        const reset = () => {
            streakRef.current = 0;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
        const scheduleReset = () => {
            if (timeoutRef.current)
                clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(reset, ttl);
        };
        const listener = (e) => {
            if (e.repeat) {
                return;
            }
            if (e.key.toLowerCase() !== targetKey) {
                return;
            }
            streakRef.current += 1;
            scheduleReset();
            handlerRef.current(streakRef.current, reset);
        };
        window.addEventListener('keydown', listener);
        return () => {
            window.removeEventListener('keydown', listener);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [key, ttl]);
}
